import { render } from "./ListeManifestPage.vue?vue&type=template&id=b3af2d80&ts=true"
import script from "./ListeManifestPage.vue?vue&type=script&lang=ts"
export * from "./ListeManifestPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__